import type { CopiedImportMapping } from './import-mapping-clipboard.helpers';

/**
 * In-memory clipboard for import-tab mapping copy/paste. Ephemeral — not the
 * system clipboard, so it never collides with element copy JSON on Elements.
 */
let copiedMapping: CopiedImportMapping | null = null;

/** Store a mapping reference for a later paste onto selected import rows. */
export const setCopiedImportMapping = (mapping: CopiedImportMapping): void => {
  copiedMapping = mapping;
};

/** Read the last copied import mapping, if any. */
export const getCopiedImportMapping = (): CopiedImportMapping | null =>
  copiedMapping;

/** Clear the import mapping clipboard (tests). */
export const clearCopiedImportMapping = (): void => {
  copiedMapping = null;
};
